import { Component } from '@verndale/core';
import Cookies from 'js-cookie';
import createScrollShapes from '../helpers/createScrollShapes';
import addFormLabelsPlaceholder from '../helpers/addFormLabelsPlaceholder';
import setupPhoneInput from '../helpers/setupPhoneInput';

class PopUpBanner extends Component {
  setupDefaults() {
    this.id = this.el.dataset.id;
    this.cookieName = `loftware_popup_${this.id}`;

    this.dom = {
      image: this.el.querySelector('.pop-up-banner__shape'),
      closeButton: this.el.querySelector('.pop-up-banner__close'),
      submitBtn: this.el.querySelector('.FormSubmitButton'),
      inputUrl: this.el.querySelector('input[name="success_url"]')
    };

    this.displayBanner();
    if (this.dom.image) this.buildShapes();
    addFormLabelsPlaceholder(this.el);
    setupPhoneInput(this.el);
  }

  addListeners() {
    this.dom.closeButton.addEventListener('click', this.handleClose.bind(this));
    this.dom.submitBtn.addEventListener('click', this.redirect.bind(this));
  }

  redirect(e) {
    e.preventDefault();
    if (!this.dom.inputUrl && !this.dom.inputUrl?.value) return;
    window.open(this.dom.inputUrl.value, '_blank');
  }

  open() {
    this.el.style.display = 'block';
  }

  displayBanner() {
    if (Cookies.get(this.cookieName)) {
      return this.el.remove();
    }
    this.open();
  }

  buildShapes() {
    this.dom.shapes = createScrollShapes({
      containerEl: this.dom.image,
      count: 6,
      prefix: 'pop-up-banner__image-',
      scrollAnimate: false
    });
  }

  handleClose() {

    Cookies.set(this.cookieName, this.id, {
      expires: parseInt(this.el.dataset.cookieExpiration, 10) || 1,
      path: '/',
      sameSite: 'strict'
    });
    this.el.remove();
  }
}

export default PopUpBanner;
